import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M22 12c0 5.523-4.477 10-10 10a9.96 9.96 0 0 1-4.364-1H5a2 2 0 0 1-2-2v-2.636A9.96 9.96 0 0 1 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10M8 11a1 1 0 1 0 0 2 1 1 0 0 0 0-2m3 1a1 1 0 1 1 2 0 1 1 0 0 1-2 0m5-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2",
      clipRule: "evenodd"
    }
  )
);
var SvgMessageDotsFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var MessageDotsFilled_default = SvgMessageDotsFilled;

export { MessageDotsFilled_default as default };
